<template>
  <NuxtRouteAnnouncer />
  <NuxtLayout>
    <NuxtPwaAssets />
    <VitePwaManifest />
    <NuxtPage />
  </NuxtLayout>
</template>
<style module>
@import url("~/css/main.css");
@import url("~/css/_helpers");
</style>
